import { WarningCircleIcon } from '@phosphor-icons/react';
import type { RecurringPayment } from '@/lib/api';
import { hasConvertedAmount } from '@/lib/recurring/money';

/**
 * Foreign-currency charges the bank has not converted yet are shown at their origin price and
 * left out of the month's total. Say so, or the totals silently understate the commitment.
 */
export function UnconvertedChargesNotice({ items }: { items: readonly RecurringPayment[] }) {
  const count = items.filter((item) => !hasConvertedAmount(item)).length;
  if (count === 0) return null;

  return (
    <div
      role="status"
      className="flex items-start gap-2.5 rounded-[var(--radius-xl)] border border-warning-border bg-warning-surface px-4 py-3"
    >
      <WarningCircleIcon size={17} weight="fill" className="mt-0.5 shrink-0 text-warning-text" aria-hidden />
      <p className="text-2xs text-warning-text sm:text-xs">
        <b>
          {count === 1
            ? '1 cobrança em moeda estrangeira sem conversão informada pelo banco.'
            : `${count} cobranças em moeda estrangeira sem conversão informada pelo banco.`}
        </b>{' '}
        {count === 1 ? 'Ela aparece' : 'Elas aparecem'} na lista pelo preço de origem e{' '}
        {count === 1 ? 'fica' : 'ficam'} fora do total do mês até a fatura fechar.
      </p>
    </div>
  );
}
